import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';

import LoginPage from 'pages/auth/Login';
import DashboardLayout from 'layout/Dashboard';
import WhitelistGate from 'components/WhitelistGate';
import NotFound from 'pages/extra-pages/NotFound';

import DashboardDefault from 'pages/dashboard/default';
import Message from 'pages/component-overview/message';
import Chat from 'pages/component-overview/chat';
import Whitelist from 'pages/component-overview/whitelist';
import Profile from 'pages/component-overview/profile';
import Account from 'pages/component-overview/account';
import Log from 'pages/component-overview/log';

import { isAuthed } from 'utils/auth';
import { WsProvider } from 'contexts/WsContext'; // ✅ tetap dipakai

function RootGate() {
  return (
    <WsProvider>
      <WhitelistGate>
        <Outlet />
      </WhitelistGate>
    </WsProvider>
  );
}

function AuthGuard({ children }) {
  if (!isAuthed()) return <Navigate to="/login" replace />;
  return children;
}

function GuestGuard({ children }) {
  return isAuthed() ? <Navigate to="/dashboard/default" replace /> : children;
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <RootGate />,
    children: [
      { index: true, element: <Navigate to="/login" replace /> },
      {
        path: 'login',
        element: (
          <GuestGuard>
            <LoginPage />
          </GuestGuard>
        )
      },
      {
        element: (
          <AuthGuard>
            <DashboardLayout />
          </AuthGuard>
        ),
        children: [
          { path: 'dashboard/default', element: <DashboardDefault /> },
          { path: 'message', element: <Message /> },
          { path: 'chat', element: <Chat /> },
          { path: 'whitelist', element: <Whitelist /> },
          { path: 'profile', element: <Profile /> },
          { path: 'account', element: <Account /> },
          { path: 'log', element: <Log /> }
        ]
      },
      { path: '*', element: <NotFound /> }
    ]
  }
]);

export default router;
